/* jshint esversion: 6 */
import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";

export default function LabTestsTrack() {
  const { booking_reference } = useParams();
  const { ApiBaseUrl } = useContext(MyContext);
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    const uid = secureLocalStorage.getItem("Userid") || "0";
    axios.get(`${ApiBaseUrl}/api/v1/lab/bookings/${booking_reference}?id=${uid}`)
      .then((res) => { if (res.data.success) setBooking(res.data.booking); });
  }, [ApiBaseUrl, booking_reference]);

  if (!booking) return <div className="width-container py-8">Loading…</div>;

  return (
    <div className="width-container py-8">
      <h1 className="text-2xl font-bold mb-2">{booking.booking_reference}</h1>
      <p>Phlebotomist: <strong>{booking.phlebotomist?.name}</strong> ({booking.phlebotomist?.qualification}) · ★ {booking.phlebotomist?.rating}</p>
      <p className="mb-4">Status: <strong>{booking.status}</strong></p>
      {booking.results?.available && (
        <div className="p-4 bg-teal-50 rounded-lg mb-4">
          <p className="font-medium">Results ready</p>
          {booking.results.report_url && <a href={booking.results.report_url} className="text-rm-primary underline" target="_blank" rel="noreferrer">Download report</a>}
          <Link to="/health-records" className="block mt-2 text-rm-primary">View in Health Records</Link>
        </div>
      )}
      <h3 className="font-semibold mb-2">Timeline</h3>
      <ul className="space-y-2">
        {(booking.status_timeline || []).map((s, i) => (
          <li key={i} className="text-sm">{s.status} — {new Date(s.timestamp).toLocaleString()}</li>
        ))}
      </ul>
    </div>
  );
}
